module.exports = __webpack_public_path__ + "img/img-panel-multimarca.83a91be0.png";